// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var mobile = Theme__Responsive$PrezzeeRibbon.mediaMax(720);

var tabletOrDesktop = Theme__Responsive$PrezzeeRibbon.mediaMin(720);

var tablet = Theme__Responsive$PrezzeeRibbon.mediaRange(720, 1261);

var desktop = Theme__Responsive$PrezzeeRibbon.mediaMin(1261);

var tabletOrMobile = Theme__Responsive$PrezzeeRibbon.mediaMax(1261);

var mobileBreakpoint = 720;

var tabletBreakpoint = 1261;

export {
  mobileBreakpoint ,
  tabletBreakpoint ,
  mobile ,
  tabletOrDesktop ,
  tablet ,
  desktop ,
  tabletOrMobile ,
}
/* mobile Not a pure module */
